<template>
    <div class="p-3">
        <div class="flex items-center">
            <slot name="table-header-action" />
        </div>
        <div class="mt-2 flex flex-col">
            <div class="overflow-auto sm:-mx-6 lg:-mx-8" :style="{ height: tableHeight }">
                <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                    <div class="overflow-hidden border border-gray-200 border-bottom-0 rounded">
                        <table class="min-w-full divide-y divide-gray-200">
                            <thead class="bg-gray-50 border-bottom">
                                <tr>
                                    <th v-for="col in columns" :key="col.key" :id="col.id ? col.id : col.key"
                                        class="px-4 py-3.5 text-left text-sm font-normal text-gray-500">
                                        {{ col.label }}
                                    </th>
                                    <th class="px-4 py-3.5 text-sm font-normal text-gray-500">Actions</th>
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-200 bg-white">
                                <tr v-for="(item, ind) in items" :key="item.id" :id="`${title.toLowerCase()}.row-${ind}`" class="hover:bg-gray-50 border-bottom">
                                    <td v-for="col in columns" :key="col.key" :id="col.id ? col.id : col.key"
                                        :class="['whitespace-nowrap px-4 text-sm text-gray-600 py-2']">
                                        <div v-if="col.key === 'image-uri'">
                                            <img :src="getValue(item, col.key)" alt="image"
                                                class="w-14 h-14 object-cover rounded" />
                                        </div>
                                        <div v-else>
                                            {{ getValue(item, col.key) }}
                                        </div>
                                    </td>
                                    <td :class="['whitespace-nowrap px-4 text-sm py-2']">
                                        <slot name="actions" :item="item" />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <slot name="pagination" />
    </div>
</template>

<script>
import moment from 'moment'

export default {
    name: 'BaseTableNew',
    props: {
        title: {
            type: String,
            default: 'Items',
        },
        items: {
            type: Array,
            required: true,
        },
        columns: {
            type: Array,
            required: true,
        },
        tableHeight: {
            type: String,
            default: '600px',
        },
    },
    computed: {
        isUserTable() {
            return this.title.toLowerCase() === 'users';
        },
    },
    methods: {
        getValue(item, key) {
            if (!item || !key) return '';
            // Handle nested "attributes.key" if exists
            if (key.includes('.')) {
                return key.split('.').reduce((obj, k) => obj?.[k], item) ?? '';
            }
            if (key === 'created-at') {
                return this.standardDateFormat(item.attributes?.[key]);
            }
            
            // Fallback: check item[key] directly
            return item[key] ?? item.attributes?.[key] ?? '';
        },
        standardDateFormat(value) {
            if (!value) return '---';
            return moment(value).format('DD/MM/YYYY hh:mm:ss');
        }
    },
};
</script>
